import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api-client";

interface AdminBusiness {
  id: string;
  name: string;
  slug: string;
  status: string;
  account_id: string;
  account_name: string;
}

interface AllBusinessesResponse {
  businesses: AdminBusiness[];
}

export type { AdminBusiness };

export function useAllBusinesses(enabled = true) {
  return useQuery({
    queryKey: ["admin", "businesses"],
    queryFn: () => api.get<AllBusinessesResponse>("/core/admin/businesses"),
    staleTime: 5 * 60 * 1000,
    enabled,
  });
}
